// extracted by mini-css-extract-plugin
export default {"chips":"thVtG3xo","chip":"q08EeuIL"};